export default __webpack_public_path__ + "static/Support-d41f6dd61ca6643249745571fb73fb66.gif";